import { render, staticRenderFns } from "./Part3.vue?vue&type=template&id=ac03e9e0&scoped=true"
var script = {}
import style0 from "./Part3.vue?vue&type=style&index=0&id=ac03e9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac03e9e0",
  null
  
)

export default component.exports